import React from 'react';
import { withRouter } from 'react-router-dom';
import { useViewport } from 'components/templates/viewportProvider';
import VideoInfoModuleMobile from 'components/templates/videoInfoModuleMobile';
import { StringUtil } from 'utils/StringUtil';
import { RouteNames } from 'router';

const WorkingAtTotalEnvironmentMobile = props => {
  const { isMobile } = useViewport();
  const {
    heading,
    sub_heading,
    paragraph,
    video,
    video_thumbnail_url,
  } = props.data.data.workingAtTESectionData;

  const subHeading = StringUtil.sliceHtml(sub_heading);
  let content = StringUtil.sliceHtml(paragraph);
  content = StringUtil.formatDescription(content, 20);

  const disabledPath = RouteNames.careers;
  let toggleButton = false;
  if (disabledPath !== props.location.pathname && isMobile) {
    toggleButton = true;
  }

  return (
    <VideoInfoModuleMobile
      heading={heading}
      subHeading={subHeading}
      content={content}
      videoData={video}
      videoThumbnailUrl={video_thumbnail_url}
      toggleButton={toggleButton}
      buttonName={''}
      variableMargin={false}
    />
  );
};

export default withRouter(WorkingAtTotalEnvironmentMobile);
